import { useEffect } from 'react';
import { gtmPushEvent } from '../utils/gtmPushEvent';

export const useDisplayDocumentGTMEvent = (docType, data) => {
  const queryParams = new URLSearchParams(window.location.search);
  const clientId = queryParams.get('c');
  const companyName = queryParams.get('n');

  useEffect(() => {
    if (!data || !clientId) return;

    const {
      title,
      brand,
      topic,
      valeo_id,
      product_name,
      product_family,
      lob,
    } = data;

    let event = {
      event: 'display_document_techassist_api',
      techassist_referrer: 'true',
      company_name_of_the_user: companyName && `${companyName} (${clientId})`,
      credentials: clientId,
      technical_ressource_type: docType,
      document_title: title,
      document_brand: brand,
      document_topic: topic,
      document_id: valeo_id,
      product: product_name,
      lob: lob,
      family: product_family && product_family.join(','),
    };

    event = Object.fromEntries(
      Object.entries(event).filter(([key, value]) => !!value)
    );
    gtmPushEvent(event);
  }, [docType, data]);
};



// WEBPACK FOOTER //
// ./src/hooks/useDisplayDocumentGTMEvent.js